module.exports = __webpack_public_path__ + "static/media/img-3.4e0807a4.jpg";